module.exports = __webpack_public_path__ + "static/img/mobilebanner3.2c44042.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/front/mobilebanner3.png
// module id = QUnJ
// module chunks = 1